const legalDocuments = {
  legal_documents: "Documentos Legales",
  legal_documents_title: "Documentos Legales",
  document_type: "Tipo de Documento",
  project_number: "Número de Proyecto",
  document: "Documento",
  supplier: "Proveedor",
  supplier_name: "Nombre del proveedor",
  filter_by_project_number: "Número de Proyecto",
  Albarán: "Albarán",
  "Albarán/proforma": "Albarán/proforma",
  "Contrato Firmado": "Contrato Firmado",
  "Corriente Pago": "Corriente Pago",
  company_id: `ID de empresa`,
};

export default legalDocuments;
